import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExclamationTriangleFill = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.40093 3.00305C10.5559 1.00305 13.4439 1.00305 14.5979 3.00305L21.9529 15.7511C23.1069 17.7511 21.6629 20.2511 19.3539 20.2511H4.64493C2.33593 20.2511 0.892934 17.7511 2.04693 15.7511L9.39993 3.00305H9.40093ZM11.9999 8.25005C12.1988 8.25005 12.3896 8.32907 12.5303 8.46972C12.6709 8.61037 12.7499 8.80114 12.7499 9.00005V12.7501C12.7499 12.949 12.6709 13.1397 12.5303 13.2804C12.3896 13.421 12.1988 13.5001 11.9999 13.5001C11.801 13.5001 11.6103 13.421 11.4696 13.2804C11.329 13.1397 11.2499 12.949 11.2499 12.7501V9.00005C11.2499 8.80114 11.329 8.61037 11.4696 8.46972C11.6103 8.32907 11.801 8.25005 11.9999 8.25005ZM11.9999 16.5001C12.1988 16.5001 12.3896 16.421 12.5303 16.2804C12.6709 16.1397 12.7499 15.949 12.7499 15.7501C12.7499 15.5511 12.6709 15.3604 12.5303 15.2197C12.3896 15.0791 12.1988 15.0001 11.9999 15.0001C11.801 15.0001 11.6103 15.0791 11.4696 15.2197C11.329 15.3604 11.2499 15.5511 11.2499 15.7501C11.2499 15.949 11.329 16.1397 11.4696 16.2804C11.6103 16.421 11.801 16.5001 11.9999 16.5001Z",
		fill: "currentcolor"
	})]
});
export default SvgExclamationTriangleFill;
